const TSUBO_PER_SQUARE_METER = 0.3025;

const hasPositiveArea = (
  areaTsubo: number | null | undefined,
): areaTsubo is number =>
  typeof areaTsubo === "number" &&
  Number.isFinite(areaTsubo) &&
  areaTsubo > 0;

export const squareMetersToTsubo = (squareMeters: number): number =>
  Math.round(squareMeters * TSUBO_PER_SQUARE_METER * 100) / 100;

export const calculateMonthlyAmount = (
  unitPrice: number | null | undefined,
  areaTsubo: number | null | undefined,
): number | undefined => {
  if (
    typeof unitPrice !== "number" ||
    !Number.isFinite(unitPrice) ||
    !hasPositiveArea(areaTsubo)
  ) {
    return undefined;
  }
  return Math.round(unitPrice * areaTsubo);
};

export const calculateTsuboUnitPrice = (
  monthlyAmount: number | null | undefined,
  areaTsubo: number | null | undefined,
): number | undefined => {
  if (
    typeof monthlyAmount !== "number" ||
    !Number.isFinite(monthlyAmount) ||
    !hasPositiveArea(areaTsubo)
  ) {
    return undefined;
  }
  return Math.round(monthlyAmount / areaTsubo);
};

export const calculateTotalTsuboUnitPrice = (
  rentUnitPrice: number | null | undefined,
  maintenanceFeeUnitPrice: number | null | undefined,
): number | undefined => {
  const hasRent = typeof rentUnitPrice === "number";
  const hasMaintenance = typeof maintenanceFeeUnitPrice === "number";
  if (!hasRent && !hasMaintenance) return undefined;
  return (rentUnitPrice ?? 0) + (maintenanceFeeUnitPrice ?? 0);
};

export const calculateWeightedTsuboUnitPrice = (
  rows: Array<{
    monthlyAmount: number | null | undefined;
    areaTsubo: number | null | undefined;
  }>,
): number | undefined => {
  const validRows = rows.filter(
    (row) =>
      typeof row.monthlyAmount === "number" &&
      Number.isFinite(row.monthlyAmount) &&
      hasPositiveArea(row.areaTsubo),
  );
  const totalArea = validRows.reduce(
    (sum, row) => sum + (row.areaTsubo ?? 0),
    0,
  );
  if (totalArea === 0) return undefined;
  const totalMonthly = validRows.reduce(
    (sum, row) => sum + (row.monthlyAmount ?? 0),
    0,
  );
  return Math.round(totalMonthly / totalArea);
};
